import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  InputType,
  ValidationRule,
} from "../services/types/ComponentTypes";

export const screen_188_bill_allocations_add: any[] = [
  {
    "componentType": "screenGroup",
    "title": "Bill wise allocations",
    "style": {},
    "childComponents": [
      {
        "componentType": "form",
        "Name": "bill_allocations",
        "TableName": "bill_allocations",
        "Plugins": [
          {
            "type": "api"
          }
        ],
        "columnNumber": "m1 t1 w1",
        "style": {
          "padding": 10,
          "backgroundColor": "#ffffff",
          "direction": "column"
        },
        "Fields": [
          {
            "componentType": "fieldGroup",
            "Label": "Bill allocation details",
            "BindValue": "con_bill_allocation_details",
            "style": {
              "direction": "column"
            },
            "childComponents": [
              {
                "componentType": "searchableDropdown",
                "name": "drp_customer",
                "label": "Customer name",
                "placeholder": "Select customer",
                "required": true,
                "lookupName": "customers",
                "options": [],
                "Json_Attribute": "customer_id",
                "validation": [
                  {
                    "rule": "required",
                    "message": "Customer name is required"
                  }
                ]
              }
            ]
          },
          {
            "componentType": "subModule",
            "name": "bill_allocations_unregistered",
            "label": "Unregistered receipt details",
            "tableName": "bill_allocations_unregistered_split",
            "lookupName": "customer_unregistered_receipts",
            "parentField": "drp_customer",
            "DisableAddNewRow": true,
            "enableDeleteAction": false,
            "enableSearch": true,
            "BindValue": "bill_allocations_unregistered_split",
            "childControls": [
              {
                "componentType": "textField",
                "name": "txt_reciept_no",
                "label": "Receipt No.",
                "inputType": "text",
                "Json_Attribute": "reciept_no",
                "disabled": true,
                "BindValue": "txt_reciept_no"
              },
              {
                "componentType": "dateField",
                "name": "txt_receipt_date",
                "label": "Receipt date",
                "Json_Attribute": "receipt_date",
                "disabled": true,
                "BindValue": "txt_receipt_date"
              },
              {
                "componentType": "textField",
                "name": "txt_receipt_amount",
                "label": "Receipt amount",
                "inputType": "number",
                "Json_Attribute": "receipt_amount",
                "defaultValue": "0",
                "disabled": true,
                "BindValue": "txt_receipt_amount"
              },
              {
                "componentType": "textField",
                "name": "txt_unregistered_amount",
                "label": "Unregistered amount",
                "inputType": "number",
                "Json_Attribute": "unregistered_amount",
                "defaultValue": "0",
                "disabled": true,
                "BindValue": "txt_unregistered_amount"
              },
              {
                "componentType": "textField",
                "name": "txt_remarks",
                "label": "Details",
                "inputType": "text",
                "Json_Attribute": "remarks",
                "disabled": true,
                "BindValue": "txt_remarks"
              }
            ]
          },
          {
            "componentType": "subModule",
            "name": "invoice_recivebles",
            "label": "Invoice details",
            "billAllocationMode": true,
            "tableName": "bill_allocations_invoice_split",
            "lookupName": "customer_invoice_details",
            "parentField": "drp_customer",
            "DisableAddNewRow": true,
            "enableDeleteAction": false,
            "enableSearch": true,
            "BindValue": "bill_allocations_invoice_split",
            "childControls": [
              {
                "componentType": "textField",
                "name": "txt_invoice_no",
                "label": "Invoice No.",
                "inputType": "text",
                "Json_Attribute": "invoice_no",
                "disabled": true,
                "BindValue": "txt_invoice_no"
              },
              {
                "componentType": "textField",
                "name": "txt_due_amount",
                "label": "Due amount",
                "inputType": "number",
                "Json_Attribute": "due_amount",
                "defaultValue": "0",
                "disabled": true,
                "BindValue": "txt_due_amount"
              },
              {
                "componentType": "searchableDropdown",
                "name": "drp_unregistered_receipt",
                "label": "Receipt / credit source",
                "placeholder": "Select unadjusted receipt or credit note",
                "required": false,
                "lookupName": "customer_unregistered_receipts",
                "parentField": "drp_customer",
                "options": [],
                "Json_Attribute": "ledger_unregistered_id",
                "BindValue": "drp_unregistered_receipt"
              },
              {
                "componentType": "textField",
                "name": "txt_max_allocate",
                "label": "",
                "inputType": "number",
                "defaultValue": "0",
                "disabled": true,
                "IsHidden": true,
                "showInSummary": false,
                "style": { "display": "none" },
                "BindValue": "txt_max_allocate"
              },
              {
                "componentType": "textField",
                "name": "txt_amount",
                "label": "Allocate amount",
                "inputType": "number",
                "Json_Attribute": "amount",
                "defaultValue": "0",
                "BindValue": "txt_amount",
                "validation": [
                  {
                    "rule": "condition",
                    "condition": "[txt_amount] <= [txt_due_amount]",
                    "message": "Allocate amount cannot be greater than due amount"
                  },
                  {
                    "rule": "condition",
                    "condition": "[txt_amount] <= [txt_max_allocate]",
                    "message": "Allocate amount cannot exceed the lower of due amount and unregistered receipt balance"
                  }
                ]
              },
              {
                "componentType": "textField",
                "name": "txt_due_after_allocation",
                "label": "Due after allocation",
                "inputType": "number",
                "Json_Attribute": "due_after_allocation",
                "defaultValue": "0",
                "disabled": true,
                "BindValue": "txt_due_after_allocation"
              },
              {
                "componentType": "textField",
                "name": "txt_remaining_unregistered",
                "label": "Unregistered balance",
                "inputType": "number",
                "Json_Attribute": "remaining_unregistered",
                "defaultValue": "0",
                "disabled": true,
                "BindValue": "txt_remaining_unregistered"
              }
            ],
            "FooterControls": [
              {
                "componentType": "textField",
                "BindValue": "txt_5",
                "IncludeLabel": false,
                "IsReadOnly": true,
                "style": {
                  "display": "none"
                }
              },
              {
                "componentType": "textField",
                "BindValue": "txt_9",
                "IncludeLabel": false,
                "IsReadOnly": true,
                "style": {
                  "display": "none"
                }
              },
              {
                "componentType": "textField",
                "BindValue": "txt_6",
                "IncludeLabel": false,
                "IsReadOnly": true,
                "style": {
                  "display": "none"
                }
              },
              {
                "componentType": "textField",
                "BindValue": "txt_7",
                "IncludeLabel": false,
                "IsReadOnly": true,
                "style": {
                  "display": "none"
                }
              },
              {
                "componentType": "textField",
                "BindValue": "txt_8",
                "IncludeLabel": false,
                "IsReadOnly": true,
                "style": {
                  "display": "none"
                }
              },
              {
                "IncludeLabel": false,
                "Label": "Amount",
                "PlaceHolder": "",
                "IsMandatory": false,
                "BindValue": "txt_net_amount",
                "Json_Attribute": "net_amount",
                "componentType": "textField",
                "showInSummary": false,
                "IsReadOnly": true,
                "ExpressionV2": "[SUM:txt_amount]",
                "IsVerticalView": true,
                "inputType": "number",
                "Default_Value": "0",
                "validation": [
                  {
                    "rule": "condition",
                    "condition": "[net_amount] > 0",
                    "message": "Amount must be greater than zero"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "componentType": "button",
        "name": "Submit",
        "onPressAction": "save",
        "style": {
          "backgroundColor": "#22c55e"
        }
      }
    ]
  }
];
